import Vue from 'vue';
import VueRouter from 'vue-router';
import routerConstantMap from './router-constant';
import routerAsyncMap from './router-async';
import routerLabsMap from './router-labs';

// 开发环境的 labs 路由
if (process.env.NODE_ENV === 'development') {
  routerConstantMap.push(...routerLabsMap);
}

Vue.use(VueRouter);

// 解决编程式路由往同一地址跳转时会报错的情况
// const originalPush = VueRouter.prototype.push;
// const originalReplace = VueRouter.prototype.replace;

// // push
// VueRouter.prototype.push = function push(location, onResolve, onReject) {
//   if (onResolve || onReject) { return originalPush.call(this, location, onResolve, onReject); }
//   return originalPush.call(this, location).catch((err) => console.log(err));
// };

// // replace
// VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
//   if (onResolve || onReject) { return originalReplace.call(this, location, onResolve, onReject); }
//   return originalReplace.call(this, location).catch((err) => console.log(err));
// };

const routerMap = [...routerConstantMap, ...routerAsyncMap];

// 静态路由. 不需要权限检测
export { routerConstantMap };

// 异步动态路由
export { routerAsyncMap };

export { routerLabsMap };

const createRouter = () => new VueRouter({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: routerMap || [],
});

const router = createRouter();


// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
